import {createAction, props} from '@ngrx/store';
import {CreateRecurrencesRequestInterface, PaymentExecutionInterface, SellPreviewResponseInterface} from 'sp-arch-lib';
import {CompleteSelling} from 'sp-ui-lib';

export const retrieveSell = createAction(
  '[ConcludeSelling] Retrieve Sell',
  props<{ idOperation: number }>()
);

export const retrieveSellSuccess = createAction(
  '[ConcludeSelling] Retrieve Sell Success',
  props<{ operation: CompleteSelling }>()
);

export const retrieveSellFailure = createAction(
  '[ConcludeSelling] Retrieve Sell Failure'
);

export const executePayment = createAction(
  '[ConcludeSelling] Execute Payment',
  props<{ payment: PaymentExecutionInterface }>()
);

export const executePaymentFailure = createAction(
  '[ConcludeSelling] Execute Payment Failure'
);

export const executePaymentConcluded = createAction(
  '[ConcludeSelling] Execute Payment Concluded',
  props<{ sellResponse: Partial<SellPreviewResponseInterface> }>()
);

export const manageRedirect = createAction(
  '[ConcludeSelling] Manage Redirect',
  props<{ sellResponse: Partial<SellPreviewResponseInterface> }>()
);

export const resetOperationAvailability = createAction(
  '[ConcludeSelling] Reset Operation Availability'
);

export const setLoadingContent = createAction(
  '[ConcludeSelling] Set Loading Content',
  props<{ spinner: boolean }>()
);

export const prepareConcludeSellingAction = createAction(
  '[ConcludeSelling] Prepare Conclude Selling',
  props<{ configuration: CreateRecurrencesRequestInterface }>()
);
